import {
    GET_ALL_BOOTHS,
    ADD_BOOTH,
    EDIT_BOOTH,
    DELETE_BOOTH,
    GET_BOOTH,
    CLEAR_BOOTH,
} from '../actions/BoothActions'
import { persistReducer } from 'redux-persist';
import storage from 'localforage';

const persistConfig = {
    key: 'booths',
    storage,
};

const initialState = {
    data: [],
    totalBooths: 0,
    totalPages: 0,
    currentPage: 1,

    latestUpdate: '',
    loading: false,
    error: '',

    booth: null
}

const BoothReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_BOOTH: {
            let tempArray = Object.assign({}, state.allBooths)
            tempArray.rows = [action.payload, ...state.allBooths.rows]
            return {
                ...state,
                allBooths: tempArray,
            }
        }
        case EDIT_BOOTH: {
            let tempArray = Object.assign({}, state.allBooths)
            let target = tempArray.rows.findIndex(item => {return item.id == action.payload.id})
            tempArray.rows[target] = action.payload            
            return {
                ...state,
                allBooths: tempArray,
            }
        }
        case DELETE_BOOTH: {
            let tempArray = Object.assign({}, state.allBooths)
            let newArray = tempArray.rows.filter(item => {return item.id !== action.payload})
            tempArray.rows = newArray            
            return {
                ...state,
                allBooths: tempArray,
            }
        }
        case GET_ALL_BOOTHS: {
            return {
                ...state,
                data: action.payload.booths.booths,
                currentPage: action.payload.booths.currentPage,
                totalBooths: action.payload.booths.totalElements,
                totalPages: action.payload.booths.totalPages,
            }
        }
        case GET_BOOTH: {
            return {
                ...state,
                booth: action.payload.booth,
            }
        }
        case CLEAR_BOOTH: {
            return {
                ...state,
                booth: '',
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default persistReducer(persistConfig, BoothReducer);
